import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { useEffect, useState } from "react";

const RequireAuth = () => {
  const { profile, getToken, userRole, isUserPaymentValid } = useAuth();
  const location = useLocation();
  const [redirectTo, setRedirectTo] = useState(null);

  useEffect(() => {
    const token = getToken()?.token;
    const hasUserCreatedProfile = profile?.firstName?.length > 0;
    const isOnCreateProfilePage = location.pathname === "/createprofile";
    const isAdmin = userRole === "admin";
    if (!token) {
      setRedirectTo("/login");
    } else if (hasUserCreatedProfile && isOnCreateProfilePage){
      setRedirectTo("/")
    }
     else if (
      "firstName" in profile &&
      !isOnCreateProfilePage &&
      !isAdmin &&
      !hasUserCreatedProfile
    ) {
      setRedirectTo("/createprofile");
    } else {
      setRedirectTo(null);
    }
  }, [getToken, profile, location.pathname, userRole]);

  if (redirectTo) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
